export default {
    init() {
        // JavaScript to be fired on all pages
        $('.sub-menu >.current-menu-item').closest('.sub-menu').addClass('d-block');
        $('.d-block').closest('.menu-item').children('a').before('<i class="fa fa-angle-up iconMenu" aria-hidden="true"></i>');

        $('.sub-menu').not('.d-block').addClass('d-none');
        $('.sub-menu').not('.d-block').closest('.menu-item').children('a').before('<i class="fa fa-angle-down iconMenu" aria-hidden="true"></i>');

        $('.iconMenu').click(function () {
            if ($(this).closest('li').find('.sub-menu').hasClass('d-block')) {
                $(this).closest('li').find('.sub-menu').removeClass('d-block');
                $(this).closest('li').find('.sub-menu').addClass('d-none');

                $(this).removeClass('fa-angle-up');
                $(this).addClass('fa-angle-down');
            } else {
                $(this).closest('li').find('.sub-menu').removeClass('d-none');
                $(this).closest('li').find('.sub-menu').addClass('d-block');

                $(this).removeClass('fa-angle-down');
                $(this).addClass('fa-angle-up');
            }
        });

        $('footer li:first-child').after('<i class="fa fa-heart" aria-hidden="true"></i>');


        $('.liste-schritte').last().addClass('last');





        var bubbles_ival = 4000;
        var bubbles = [
            {
                name: 'andreas',
                no: 1,
                texts: ['Ihr könnt mich mal alle am Arsch lecken.','Wenn wir alle an einem Strang ziehen, schaffen wir das!', 'Wir sitzen alle in einem Boot.','*Miiaaaauuuuu*','Warte mich ruft gerade jemand an.','BETET ZUM BEETIAN!','Wollen wir uns alle gleich zusammen austauschen.','...', 'Ihr verdient alle genug Geld für eure Leistungen.', 'Wer ist eigentlich dieser Niko und wieso bezahle ich den?'],
            },
            {
                name: 'bettina',
                no: 2,
                texts: ['Haha. Witzig.','Liebling, ich habe die Vektorzeichnung gelöscht.','Niii-iiick','Was ist bloß los bei euch?','BETET ZUM BEETIAN!','Das ist schon lustig.','...','Dazu sage ich jetzt nichts.', 'Spatziiii, was ist los?', 'Ich fresse kleine Kinder zum Frühstück.', 'Ihr seht eh so hüpsch aus, nur Andi und ich schauen doof aus.', 'Nick schau nicht so viel Fernseh!', 'Mein Auto muss heute in die Werkstatt.', 'Warte kurz, die Anja ruft gerade an.', 'Wer ist eigentlich dieser Niko?'],
            },
            {
                name: 'patrick',
                no: 3,
                texts: ['Was ist niedlich und hüpft qualmend über\'n Acker? — Ein Kaminchen!','Steht ein Baum allein im Wald…','Christian, das funktioniert nicht. Oh doch..','Egal wie gut Du fährst, Züge fahren Güter.','BETET ZUM BEETIAN!','Zieh deine Hose an!','...','Ich hol mir mal kurz nen Kaffee.', 'Ich komme gleich wieder.', 'Vielen Dank Niko, für deine Tolle Arbeit.'],
            },
            {
                name: 'christian',
                no: 4,
                texts: ['Ich bin sehr unmusikalisch.','Maaaan Patrick, das funktioniert sooo.','...','Wieso funktioniert der Scheiß nicht?!?','Drecks Magento!','GANZ EHRLICH, das ist so Kacke!','BETET ZUM BEETIAN!','Ich möchte am Wochenende gerne arbeiten.', 'Ganz ehrlich!', 'Wer ist eigentlich dieser Niko?'],
            },
        ];
        bubbles.forEach(function(item){
            window['bubble_'+item['name']] = setInterval(function(){
                jQuery('.contact-card-'+item['no']+' figcaption').html(item.texts[Math.floor(Math.random() * item.texts.length)]);
            }, bubbles_ival);
        });
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js